/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const BillingLimits = core.serialization.object({
    fromDate: core.serialization.date(),
    toDate: core.serialization.date(),
    fileUploadIsLockedUntilPayment: core.serialization.boolean(),
    sheetIsLockedUntilPayment: core.serialization.boolean(),
});
